"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonPlaceholder = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var AddonPlaceholder_less_1 = __importDefault(require("./AddonPlaceholder.less"));
var AddonPlaceholder = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, AddonPlaceholder_less_1.default['addon-container']) },
        react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['content'] },
            react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['logo-container'] },
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-logo'] })),
            react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['info-container'] },
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] }),
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] }),
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] }),
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] }))),
        react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['buttons-container'] },
            react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['action-buttons-container'] },
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] }),
                react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] })),
            react_1.default.createElement("div", { className: AddonPlaceholder_less_1.default['placeholder-pill'] }))));
};
exports.AddonPlaceholder = AddonPlaceholder;
